import { render, staticRenderFns } from "./UserDetailStatisticTile.vue?vue&type=template&id=8fee25ba&scoped=true&lang=pug&"
import script from "./UserDetailStatisticTile.vue?vue&type=script&lang=js&"
export * from "./UserDetailStatisticTile.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailStatisticTile.vue?vue&type=style&index=0&id=8fee25ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fee25ba",
  null
  
)

export default component.exports